"use client";

import React from "react";
import { ArrowRight, Activity, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EndoskopiHakkinda() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169252" id="operasyon-detayları" className="relative bg-background text-foreground overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-0 right-0 -mr-40 -mt-40 w-[600px] h-[600px] bg-[var(--primary)]/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">

          {}
          <div ref={leftRef} className={`lg:col-span-5 flex flex-col items-start transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[var(--secondary)] text-[var(--primary)] font-sans font-medium text-xs tracking-wider uppercase mb-6 border border-[var(--border)]">
              <Activity className="w-4 h-4" />
              <span>Klinik Mükemmeliyet</span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-[3rem] leading-[1.2] font-serif font-bold text-foreground mb-6 tracking-tight">Gömülü Dişlere <br />Konforlu Veda</h2>

            <p className="text-base text-muted-foreground font-sans font-normal mb-10 leading-relaxed max-w-xl">Gömülü dişler, çene kemiği veya diş eti altında kalmış ve normal şekilde sürememiş dişlerdir; en sık 20 yaş dişlerinde görülür ve zamanla ağrı, şişlik, enfeksiyon veya komşu dişlerde hasara yol açabilir. Kayseri’de hizmet veren kliniğimizde, gömülü diş operasyonları modern cerrahi teknikler ve ileri görüntüleme yöntemleri ile güvenli ve konforlu bir şekilde gerçekleştirilmektedir.</p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground border-0 shadow-lg shadow-[var(--primary)]/10 rounded-sm px-8 h-14 text-sm font-sans font-semibold tracking-wide transition-all duration-300 hover:scale-[1.01] group">
                <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab>
                  Randevu Al
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>

            <div className="mt-12 flex items-center gap-8 text-xs text-muted-foreground font-sans font-medium uppercase tracking-widest">
              <div className="flex items-center gap-3">
                <ShieldCheck className="w-4 h-4 text-primary" />
                <span>Üstün Hijyen</span>
              </div>
              <div className="flex items-center gap-3">
                <Activity className="w-4 h-4 text-primary" />
                <span>Dijital Planlama</span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 relative transition-all duration-1000 delay-200 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="relative z-10 lg:translate-x-8 lg:scale-100">
              {}
              <div className="absolute inset-0 bg-[var(--primary)]/5 rounded-sm blur-3xl transform rotate-1 scale-105" />

              <div className="relative bg-card backdrop-blur-sm border border-[var(--border)] rounded-sm p-2 shadow-xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/endoscopy_3d_render_medical_procedure.png" alt="Modern Klinik Ortamı" className="w-full h-auto rounded-sm object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-700" />

                {}
                <div className="absolute -bottom-6 -left-6 bg-background/95 backdrop-blur-md border border-[var(--border)] rounded-sm p-5 shadow-lg flex items-center gap-5 animate-none">
                  <div className="w-10 h-10 rounded-full bg-[var(--secondary)] flex items-center justify-center">
                    <Activity className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <p className="text-[10px] text-muted-foreground font-sans font-bold uppercase tracking-widest">Başarı Oranı</p>
                    <p className="text-xl font-serif font-bold text-foreground">100%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}